import _ from 'lodash';
import React from 'react';
import classnames from 'classnames';

export default class Message extends React.Component {

  render() {
    let message = this.props.message;
    if (_.isEmpty(message)) {
      return null;
    }
    return (
      <div className={classnames('ui', this.props.className, {blue: message.info}, {yellow: message.warn}, {green: message.success}, {red: message.error}, 'message')}>
        {message.header &&
          <div className="header">{message.header}</div>
        }
        {message.error || message.warn || message.info || message.success}
        {this.props.closable &&
          <i className="close icon" onClick={this.props.dismiss} />
        }
      </div>
    );
  }
}

Message.propTypes = {
  message: React.PropTypes.object,
  className: React.PropTypes.string,
  dismiss: React.PropTypes.func,
  closable: React.PropTypes.bool,
};



// WEBPACK FOOTER //
// ./~/sp-components/components/Message/index.js